(function () {
    'use strict';

    angular
        .module('homeDashboardControllers')
        .controller('DashboardActionPlanUpdateStatusController', Controller);

    Controller.$inject = ['$scope', 'recomActionPlanUpdateStatusService'];

    function Controller($scope, recomActionPlanUpdateStatusService) {

        recomActionPlanUpdateStatusService
            .getAvailableBusinessUnits()
            .then(function (bUnits) {
                $scope.availableRecomBusinessUnits = bUnits;
            });

    }
})();